import graphqlSelectInput from '../graphqlSelectInput';
import { patientRooms } from '@/graph/rooms';

export default graphqlSelectInput({
  entityName: 'Room',
  label: 'Room',
  placeholder: '',
  graphqlList: patientRooms,
  getOptionValue: option => (option ? parseInt(option.value, 10) : undefined),
  isSearchable: true,
});
